// Game media shared by both runtimes, templates, export and the website worker.
// Keep this catalog import-free so Node can load an exact snapshot of its bytes.
const IMAGE_FILES = Object.freeze({
  cat: "assets/cat.webp",
  cat128: "assets/cat-128.webp",
  cat192: "assets/cat-192.webp",
  catRig: "assets/cat-rig.webp",
});
export const AUDIO_GROUPS = Object.freeze({
  scratch: Object.freeze(["mark-a", "mark-b", "mark-c"]),
  board: Object.freeze(["board-enter"]),
  cat: Object.freeze(["cat-found"]),
  mistake: Object.freeze(["mistake"]),
  finish: Object.freeze(["level-complete"]),
});
const AUDIO_FILES = Object.freeze(Object.fromEntries(
  Object.values(AUDIO_GROUPS).flat().map((name) => [name, `assets/audio/${name}.mp3`]),
));
export const GAME_ASSET_FILES = Object.freeze([
  ...Object.values(IMAGE_FILES),
  ...Object.values(AUDIO_FILES),
]);

/** URLs resolve against the document, including when game modules live in chunks/. */
export function createGameAssets(base) {
  if (base !== "/" && base !== "./") throw new Error("Game asset base must be / or ./");
  return Object.freeze({
    ...Object.fromEntries(Object.entries(IMAGE_FILES).map(([name, file]) => [name, `${base}${file}`])),
    audio: Object.freeze(Object.fromEntries(Object.entries(AUDIO_FILES).map(([name, file]) => [name, `${base}${file}`]))),
  });
}
